import { motion } from "framer-motion";

export const PhoneMockup = ({
  src,
  alt,
  tilt = -6,
  float = true,
  priority = false,
  className = "",
  delay = 0,
}) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    <div style={{ transform: `rotate(${tilt}deg)` }}>
      <motion.div
        animate={float ? { y: [0, -10, 0] } : undefined}
        transition={float ? { duration: 5.5, repeat: Infinity, ease: "easeInOut" } : undefined}
        className="overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-[0_30px_70px_-24px_rgba(15,23,42,0.35)]"
        data-testid={`phone-mockup-${alt.toLowerCase().replace(/[^a-z]+/g, "-")}`}
      >
        <img
          src={src}
          alt={alt}
          loading={priority ? "eager" : "lazy"}
          fetchPriority={priority ? "high" : "auto"}
          className="w-full"
        />
      </motion.div>
    </div>
  </motion.div>
);
